import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import Icon from '../../../common/Icon';
import globalTranslations from '../../../../i18n/globalTranslations';

const CHECKOUT_CART_MESSAGES = {
  recommendedProductsLabel: (
    <FormattedMessage
      id="checkout.cart.recommendedProductsLabel"
      defaultMessage="You might also be interested in these products"
    />
  ),
};

export const SLIDES_TO_SHOW = 4;

const CheckoutRecommendedProductsLabelRow = ({
  intl,
  slideCount,
  currentSlide,
  onClickNext,
  onClickPrev,
  isLoading,
  isAnimating,
}) => {
  const totalPages = Math.ceil(slideCount / SLIDES_TO_SHOW);
  // Derive page from actual slider position so prev/next stay in sync
  const currentPage =
    slideCount > 0
      ? Math.min(Math.floor(currentSlide / SLIDES_TO_SHOW), totalPages - 1)
      : 0;

  const handlePrevClick = () => {
    if (currentPage > 0 && !isAnimating && onClickPrev) {
      onClickPrev();
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages - 1 && !isAnimating && onClickNext) {
      onClickNext();
    }
  };

  const isPrevDisabled = isLoading || currentPage <= 0;
  const isNextDisabled = isLoading || currentPage >= totalPages - 1;

  return (
    <div className="CheckoutCart__recommended-products-label-row">
      <span className="CheckoutCart__recommended-products-label">
        {CHECKOUT_CART_MESSAGES.recommendedProductsLabel}
      </span>
      <span className="CheckoutCart__recommended-products-arrows">
        <Button
          className="CheckoutCart__recommended-products-arrow-prev"
          disabled={isPrevDisabled}
          onClick={handlePrevClick}
          aria-label={intl.formatMessage(globalTranslations.previousProducts)}
        >
          <Icon name="chevron-left" />
        </Button>
        <Button
          className="CheckoutCart__recommended-products-arrow-next"
          disabled={isNextDisabled}
          onClick={handleNextClick}
          aria-label={intl.formatMessage(globalTranslations.nextProducts)}
        >
          <Icon name="chevron-right" />
        </Button>
      </span>
    </div>
  );
};

CheckoutRecommendedProductsLabelRow.propTypes = {
  intl: intlShape.isRequired,
  slideCount: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
  isAnimating: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClickPrev: PropTypes.func,
  onClickNext: PropTypes.func,
};

export default injectIntl(CheckoutRecommendedProductsLabelRow);
